import { useMemo } from 'react';

import { useQuery, queryOptions } from '@tanstack/react-query';

import { STALE_TIMES } from '#lib/queryConstants';

import { listCustomFieldDefs } from '../../api/crmApi';

export const customFieldsKeys = {
	all: ['crm', 'customFields'],
	byEntity: (entityType) => ['crm', 'customFields', entityType],
};

export const customFieldDefsOptions = (entityType) =>
	queryOptions({
		queryKey: customFieldsKeys.byEntity(entityType),
		queryFn: async () => {
			const res = await listCustomFieldDefs(entityType);
			return res.fields ?? [];
		},
		staleTime: STALE_TIMES.STANDARD,
	});

export function useCustomFieldDefs(entityType) {
	return useQuery(customFieldDefsOptions(entityType));
}

/** Returns only visible fields, sorted by sortOrder. */
export function useVisibleFieldDefs(entityType) {
	const query = useCustomFieldDefs(entityType);
	const data = useMemo(
		() =>
			(query.data ?? [])
				.filter((f) => f.isVisible !== false)
				.sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0)),
		[query.data],
	);
	return { ...query, data };
}

/** Returns only default (built-in) fields. */
export function useDefaultFieldDefs(entityType) {
	const query = useCustomFieldDefs(entityType);
	const data = useMemo(() => (query.data ?? []).filter((f) => f.isDefault), [query.data]);
	return { ...query, data };
}
